import moment from 'moment';

export const convertToISOString = (date: Date, keepOffset = true): string => moment(date).toISOString(keepOffset);
